<template>
  <mdb-modal removeBackdrop size="md" :show="modalShow" @close="handleClose">
    <mdb-modal-header class="text-center" color="indigo">
      <mdb-modal-title tag="h4" bold class="w-100 text-white">{{
        $t("gameleokeyword_name")
      }}</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body class="mx-3" color="white">
      <mdb-input
        :label="$t('gameleokeyword_name')"
        type="text"
        v-model="gameleoKeyword"
      />
      <mdb-input
        :label="$t('gameleokeyword_fullname')"
        type="text"
        v-model="gameleoKeywordName"
      />
      <mdb-input
        :label="$t('gameleokeyword_price')"
        type="number"
        v-model="gameleoKeywordPrice"
      />
      <mdb-input
        :label="$t('gameleokeyword_duration')"
        type="number"
        v-model="gameleoKeywordDuration"
      />
    </mdb-modal-body>
    <mdb-modal-footer center>
      <mdb-btn @click="addChangeGameleoKeyword" color="indigo"
        >{{ $t("save") }}<mdb-icon icon="paper-plane" class="ml-1"
      /></mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalBody,
  mdbInput,
  mdbModalFooter,
  mdbModalTitle,
  mdbIcon
} from "mdbvue";
export default {
  name: "EditGameleoKeyword",
  props: {
    modalShow: Boolean,
    addGameleoKeywordState: Boolean,
    id: Number,
    name: String,
    price: Number,
    keyword: String,
    duration: Number
  },
  components: {
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbInput,
    mdbModalFooter,
    mdbModalTitle,
    mdbIcon
  },
  data() {
    return {
      gameleokeywordpath: "/1.0/front/gameleo/keyword",
      gameleoKeywordId: this.id,
      gameleoKeyword: this.keyword,
      gameleoKeywordName: this.name,
      gameleoKeywordPrice: this.price,
      gameleoKeywordDuration: this.duration
    };
  },
  methods: {
    handleClose() {
      console.log("modal hide");
      this.$emit("modal-cancelled");
    },
    addChangeGameleoKeyword() {
      this.postdata = JSON.stringify({
        sessionid: this.$store.getters.getToken,
        name: this.gameleoKeywordName,
        keyword: this.gameleoKeyword,
        price: this.gameleoKeywordPrice,
        duration: this.gameleoKeywordDuration,
        id: this.gameleoKeywordId
      });
      this.$http 
        .post(this.gameleokeywordpath, this.postdata)
        .then(response => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("adding_gameleokeyword_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort
            });
          }
          this.$emit("modal-ok");
        })
        .catch(error => {
          this.$notify.error({
            message: this.$t("adding_gameleokeyword_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort
          });
          this.$emit("modal-ok");
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
  }
};
</script>

<style scoped></style>
